import React from 'react';
import { Spinner } from '../../components/ui';
import FunctionForm from './FunctionForm';
import { sideChipClass, fmtDate, fmtTime } from '../../utils/helpers';

export default function FunctionsMobile({ vm }) {
  const { filtered, days, loading, can, q, setQ, startAdd, startEdit, del, isTwoSided } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Functions</h1>
        <span className="muted">{filtered.length}</span>
      </div>

      <div className="mobile-toolbar">
        <input placeholder="Search..." value={q} onChange={(e) => setQ(e.target.value)}
          style={{ padding: '11px 12px', border: '1px solid var(--line)', borderRadius: 10 }} />
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add Function</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty">No functions yet.{!can.add && ' Ask the Event Owner to add functions.'}</div>
        ) : days.map(day => (
          /* One heading per day; the functions of that day follow in time order. */
          <div key={day.date || 'nodate'}>
            <div className="step-label" style={{ marginTop: 8 }}>
              {day.date ? fmtDate(day.date) : 'No date yet'}{day.items.length > 1 ? ` · ${day.items.length} functions` : ''}
            </div>
            <div className="mobile-card-list">
            {day.items.map(row => (
              <div key={row.FunctionId} className={'card card-pad mobile-record-card row-link' + (day.clashes.has(row.FunctionId) ? ' clash' : '')}
                onClick={() => vm.openRow(row)}>
                <div className="mobile-card-head">
                  <strong className="mobile-title">{row.FunctionName || '-'}</strong>
                  <div style={{ flex: 1 }} />
                  {isTwoSided && <span className={sideChipClass(row.Side)}>{row.Side}</span>}
                </div>
                <div className="mobile-meta">
                  <div>🕒 {fmtTime(row.StartTime || row.FunctionTime) || '-'}{row.EndTime ? ` – ${fmtTime(row.EndTime)}` : ''} | {row.FunctionType || '-'}</div>
                  <div className="muted">
                    {[row.Venue, row.City].filter(Boolean).join(' | ') || '-'}
                    <span className="chip pend" style={{ marginLeft: 6 }}>{row.Status}</span>
                  </div>
                </div>
                {(can.edit || can.delete) && (
                  <div className="mobile-actions" onClick={(e) => e.stopPropagation()}>
                    {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                    {can.delete && <button className="btn danger sm" onClick={() => del(row)}>Del</button>}
                  </div>
                )}
              </div>
            ))}
            </div>
          </div>
        ))}

      <FunctionForm vm={vm} event={vm.event} />
    </div>
  );
}
